import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from '@services/http-cache/http-cache.service';
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cacheService: HttpCacheService) {}
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET') {
      this.cacheService.invalidateCache();
      return next.handle(req);
    }
    const cachedResponse = this.cacheService.get(req.url);

    const isSave = req.headers.get('cache');
    if (cachedResponse && isSave === 'true') {
      return of(cachedResponse);
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && isSave === 'true') {
          this.cacheService.put(req.url, event);
        }
      })
    );
  }
}
